import css from 'styled-jsx/css';

const closeIconMarginRight = 10;
const closeIconSize = 10;
const closeIconInnerMargin = 5;
const inputIconPadding = closeIconInnerMargin * 2 + closeIconSize + closeIconMarginRight;

// language=CSS

export default css.global`
  .react-algolia-places {
    position: relative;
    display: flex;
  }

  .react-algolia-places .ap-suggestion {
    padding-left: 0.6em;
  }

  .react-algolia-places .ap-header {
    margin-top: 0.5em;
  }

  .react-algolia-places:not(visible) .ap-dropdown-menu {
    display: none;
  }

  /* noinspection CssMissingComma */
  .react-algolia-places .ap-with-places.ap-without-fixtures.ap-without-history .ap-header,
  .react-algolia-places .ap-with-fixtures.ap-without-places.ap-without-history .ap-header,
  .react-algolia-places
    .ap-with-history.ap-without-places.ap-without-fixtures
    .ap-header {
    display: none;
  }

  .react-algolia-places .close-icon {
    visibility: hidden;
    position: absolute;
    right: 0;
    cursor: pointer;
    margin-right: ${closeIconMarginRight}px;
    align-self: center;
  }

  .react-algolia-places .close-icon.visible {
    visibility: visible;
  }

  /* Fix ReactSVG second wrapper padding bug */
  .react-algolia-places .close-icon > div {
    display: flex;
  }

  .react-algolia-places .close-icon svg {
    width: ${closeIconSize}px;
    margin: ${closeIconInnerMargin}px;
  }

  .react-algolia-places .algolia-main {
    width: 100%;
  }

  .react-algolia-places .ap-suggestions {
    overflow-y: auto;
    max-height: 500px;
  }

  /* padding-right: relative to 'close-icon' style */
  .react-algolia-places .ap-input {
    padding-left: 16px;
  }

  .react-algolia-places .algolia-main .ap-input {
    padding-right: calc(5px + ${inputIconPadding}px);
  }

  .react-algolia-places .ap-suggestion-icon {
    margin-right: 0.6em;
    height: 100%;
    width: 1.1em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .react-algolia-places .ap-dataset-places .ap-suggestion-icon {
    margin-right: 0.34em;
  }

  .react-algolia-places .ap-suggestion-icon svg {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }

  .react-algolia-places .ap-fixture-icon {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    height: 100%;
  }

  .react-algolia-places .ap-fixture-icon svg {
    width: 1.5em;
    height: 1.5em;
    margin-right: 0.625em;
    vertical-align: middle;
    fill: #cfcfcf;
  }

  .react-algolia-places .ap-cursor {
    background: #f4f4f4;
  }

  .react-algolia-places .ap-cursor .ap-fixture-icon svg {
    transform: scale(1.1);
    fill: #aaaaaa;
  }

  .react-algolia-places .ap-dropdown-menu {
    color: #333333;
    background-color: white;
    border: 1px solid #cccccc;

    border-radius: 4px;
    padding: 0.5em;
    box-shadow: 1px 1px 32px -10px rgba(0, 0, 0, 0.62);
  }

  .react-algolia-places .ap-dropdown-menu .ap-suggestion {
    text-align: left;
    cursor: pointer;
    vertical-align: middle;
    align-items: center;
    position: relative;
  }

  .react-algolia-places .ap-dropdown-menu .ap-suggestion img {
    height: 2em;
    margin-top: 0.5em;
    margin-right: 10px;
    float: left;
  }

  .react-algolia-places .ap-dropdown-menu .ap-suggestion small {
    font-size: 0.8em;
    color: #bbbbbb;
  }

  .react-algolia-places .ap-dropdown-menu .ad-example-suggestion em {
    font-weight: bold;
    font-style: normal;
  }

  .react-algolia-places .ap-header {
    font-weight: bold;
    margin-bottom: 0.5em;
    border-bottom: 1px solid #cccccc;
    padding: 5px 16px 10px;
  }

  .react-algolia-places .ap-footer a {
    display: inline;
  }
`;



/** WEBPACK FOOTER **
 ** ./src/components/partials/AlgoliaPlaces/styles/main.js
 **/